import {CheckboxFilterBlock} from 'plugins/modules/filter/components/CheckboxFilterBlock';
import {BrowserFilters} from 'plugins/modules/filter/helpers/BrowserFilters';
import {IFilterFacet} from 'plugins/modules/filter/types';
import React, {FC, useCallback, useContext, useMemo} from 'react';
import {isBrowserContext} from 'core/helpers';
import {useFiltersRouterPush} from '../../hooks/useFiltersRouterPush';
import {FilterContext} from 'plugins/modules/filter/context/new';
import {useFiltersGtag} from 'hooks/analytics/gtag/catalog/useFiltersGtag';
import {getFilterTitleForGtag} from 'plugins/modules/filter/helpers';
import {EventAction} from 'modules/google-analytics/constants';

interface IProps {
    filter: IFilterFacet;
    withSearch?: boolean;
}

export const CheckboxFilterController: FC<IProps> = ({filter, withSearch}) => {
    const {pushRoute} = useFiltersRouterPush();
    const {filterList} = useContext(FilterContext);

    const sendFiltersGtag = useFiltersGtag();

    const filterInstance = useMemo(() => {
        if (!isBrowserContext()) {
            return null;
        }

        return BrowserFilters.getInstance();
    }, []);

    const handleApply = useCallback(
        (variantCode: string) => {
            if (!filterInstance) {
                return;
            }

            const variant = filter.variants?.find((fv) => fv.code === variantCode);

            sendFiltersGtag(getFilterTitleForGtag(filterList, filter, variant));

            const {pathName} = filterInstance.userAddOneFilterValue(filter, variantCode);
            pushRoute(pathName, undefined, {scroll: false, shallow: true});
        },
        [filterInstance, filter, filterList, pushRoute, sendFiltersGtag],
    );

    const handleDiscard = useCallback(
        (variantCode: string) => {
            if (!filterInstance) {
                return;
            }

            const variant = filter.variants?.find((fv) => fv.code === variantCode);

            sendFiltersGtag(getFilterTitleForGtag(filterList, filter, variant), EventAction.RemoveFilter);

            const {pathName} = filterInstance.userRemoveOneFilterValue(filter, variantCode);
            pushRoute(pathName, undefined, {scroll: false, shallow: true});
        },
        [filterInstance, filter, sendFiltersGtag, filterList, pushRoute],
    );

    return (
        <CheckboxFilterBlock filter={filter} onApply={handleApply} onDiscard={handleDiscard} withSearch={withSearch} />
    );
};
